import { render, staticRenderFns } from "./OctChip.vue?vue&type=template&id=009b363b&scoped=true&"
import script from "./OctChip.vue?vue&type=script&lang=js&"
export * from "./OctChip.vue?vue&type=script&lang=js&"
import style0 from "./OctChip.vue?vue&type=style&index=0&id=009b363b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b363b",
  null
  
)

export default component.exports